import React from 'react';
import './index.scss';
const CnTooltip = window.CNUI?.CnTooltip;
/**
 * 自由布局中选择有几列的setter
 * @param props
 * @constructor
 */
export default class ColumnSelectSetter extends React.Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        if (Number(nextProps.value) !== prevState.column) {
            return {
                column: Number(nextProps.value),
            };
        }
        return null; // 不需要更新 state
    }
    originValue;
    constructor(props) {
        super(props);
        const realValue = Number(this.props.value);
        this.state = {
            column: realValue,
        };
        this.originValue = realValue;
    }
    select = (index) => {
        const { onChange } = this.props;
        if (typeof index === 'number') {
            this.originValue = index;
            onChange?.(index);
        }
    };
    mouseenter = (index) => {
        const { onChange } = this.props;
        this.setState({
            column: index,
        });
        onChange?.(index);
    };
    mouseleave = () => {
        const { onChange } = this.props;
        if (typeof this.originValue === 'number') {
            onChange?.(this.originValue);
        }
    };
    render() {
        const { column } = this.state;
        return (<div onMouseLeave={this.mouseleave} className="cn-column-select-setter">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item, index) => {
                const style = {};
                if (column > index) {
                    style.backgroundColor = '#005be5';
                }
                const dom = (<div onMouseEnter={this.mouseenter.bind(this, index + 1)} onClick={this.select.bind(this, index + 1)} className="cn-column-select-setter-item" style={style}/>);
                if (CnTooltip) {
                    return <CnTooltip trigger={dom}>{index + 1}</CnTooltip>;
                }
                else {
                    return dom;
                }
            })}
      </div>);
    }
}
ColumnSelectSetter.displayName = 'ColumnSelectSetter';
